import * as React from 'react';

import { ITheme } from '@fluentui/react';

import { AppCompoundButton, AppCompoundButtonProps, getActionCompoundButtonStyles } from '@1js/acui-button';
import { AppThemeConsumer } from '@1js/acui-theme';

export class RibbonCompoundButton extends React.PureComponent<AppCompoundButtonProps, {}> {
  public render() {
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppCompoundButton
            {...this.props}
            styles={getActionCompoundButtonStyles(theme, this.props.styles)}
            dataAutomationType="RibbonCompoundButton"
          />
        )}
      </AppThemeConsumer>
    );
  }
}
